import script from "./ColorsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorsPanel.vue?vue&type=script&setup=true&lang=js"

import "./ColorsPanel.vue?vue&type=style&index=0&id=14d7f5f6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d7f5f6"]])

export default __exports__